import { useCallback, useEffect, useState } from 'react';
import {
  ACOUSTIC_THRESHOLD_UPDATED_EVENT,
  clearThresholdOverrides,
  hasEmpiricalThresholds,
  listActiveThresholdOverrides,
  readThresholdOverrideStore,
  type AcousticThresholdOverrideStore
} from '../lib/acoustic/acousticThresholdOverrides';

export function useAcousticThresholdOverrides() {
  const [store, setStore] = useState<AcousticThresholdOverrideStore>(() => readThresholdOverrideStore());

  const refresh = useCallback(() => {
    setStore(readThresholdOverrideStore());
  }, []);

  useEffect(() => {
    const onUpdate = () => refresh();
    window.addEventListener(ACOUSTIC_THRESHOLD_UPDATED_EVENT, onUpdate);
    return () => window.removeEventListener(ACOUSTIC_THRESHOLD_UPDATED_EVENT, onUpdate);
  }, [refresh]);

  const resetAll = useCallback(() => {
    clearThresholdOverrides();
    refresh();
  }, [refresh]);

  return {
    store,
    empiricalGlobalActive: hasEmpiricalThresholds(),
    activeOverrides: listActiveThresholdOverrides(),
    refresh,
    resetAll
  };
}
